import React from "react"

import MessageList from "components/Copilot/MessageList"
import { CopilotResponse } from "components/Copilot/types"

type TeacherAideHistoryProps = {
  responses?: CopilotResponse[]
  userLabel: string
}

const TeacherAideHistory: React.FC<TeacherAideHistoryProps> = ({
  responses,
  userLabel,
}) => {
  const messages = (responses || []).flatMap(({ prompt, response }) => [
    { text: prompt, fromUser: true },
    { text: response, fromUser: false },
  ])

  return (
    <section className="flex h-full min-h-0 flex-col overflow-hidden bg-[#111] text-white">
      <header className="bg-sky-950/30 flex-shrink-0 border-b border-solid border-sky-900 px-4 py-3 font-semibold text-sky-100">
        Teacher Aide History
      </header>
      {messages.length > 0 ? (
        <MessageList
          messages={messages}
          userLabel={userLabel}
          copilotLabel="Teacher Aide"
        />
      ) : (
        <p className="p-4 text-sm italic text-sky-300">
          No Teacher Aide conversations yet
        </p>
      )}
    </section>
  )
}

export default TeacherAideHistory
